// Javascript
import 'account/locale-picker'
import 'account/iframe-communication'
import 'account/account_core'
